(function() {
  'use strict';

  const images = [
    "https://cdn.shopify.com/s/files/1/0688/7964/6892/files/ChatGPT_Image_Jun_14_2026_at_10_23_36_PM.png?v=1781465559",
    "https://cdn.shopify.com/s/files/1/0688/7964/6892/files/ChatGPT_Image_Jun_14_2026_at_08_34_51_PM-2.png?v=1781458717",
    "https://cdn.shopify.com/s/files/1/0688/7964/6892/files/Before_after_rayana_2-2.png?v=1781454288",
    "https://cdn.shopify.com/s/files/1/0688/7964/6892/files/ChatGPT_Image_Jun_14_2026_at_07_51_04_PM-2.png?v=1781456366",
    "https://cdn.shopify.com/s/files/1/0688/7964/6892/files/ChatGPT_Image_Jun_14_2026_at_07_56_46_PM-2.png?v=1781456367",
    "https://cdn.shopify.com/s/files/1/0688/7964/6892/files/ChatGPT_Image_Jun_14_2026_at_07_39_08_PM-2.png?v=1781456366",
    "https://cdn.shopify.com/s/files/1/0688/7964/6892/files/IMG_4160.jpg?v=1771964513"
  ];

  const bundleData = {
    1: {
      title: "BUY 1",
      subtitle: "30 Days Supply",
      whatsappSubtitle: "+$4 Delivery",
      price: 19.99,
      compareAt: 29.99,
      badge: "SAVE $10",
      stickyLabel: "BUY 1 selected",
      variantId: 44347551940780
    },
    2: {
      title: "BUY 2",
      subtitle: "60 Days Supply",
      whatsappSubtitle: "Get FREE Delivery",
      price: 39.98,
      compareAt: 49.98,
      badge: "MOST POPULAR",
      stickyLabel: "BUY 2 selected",
      variantId: 46072798871724
    },
    3: {
      title: "BUY 3",
      subtitle: "90 Days Supply",
      whatsappSubtitle: "Save $10 + Get FREE Delivery",
      price: 49.99,
      compareAt: 59.99,
      badge: "BEST VALUE",
      stickyLabel: "BUY 3 selected",
      variantId: 45172869038252
    }
  };

  let currentIndex = 0;
  let selectedPlan = 1;

  const mainImg = document.getElementById('roux-main-img');
  const dotsContainer = document.getElementById('roux-dots');
  const prevBtn = document.getElementById('roux-prev');
  const nextBtn = document.getElementById('roux-next');

  const imageCache = new Map();
  const imagePromises = new Map();

  function money(value) {
    return '$' + Number(value).toFixed(2);
  }

  function addResourceHint(url, rel, priority) {
    if (!document.head || !url) return;

    const existing = document.head.querySelector('link[rel="' + rel + '"][href="' + url + '"]');
    if (existing) return;

    const link = document.createElement('link');
    link.rel = rel;
    link.as = 'image';
    link.href = url;

    if (priority) {
      link.setAttribute('fetchpriority', priority);
    }

    document.head.appendChild(link);
  }

  function setupImageResourceHints() {
    if (!document.head) return;

    const preconnectExists = document.head.querySelector('link[rel="preconnect"][href="https://cdn.shopify.com"]');
    if (!preconnectExists) {
      const preconnect = document.createElement('link');
      preconnect.rel = 'preconnect';
      preconnect.href = 'https://cdn.shopify.com';
      preconnect.crossOrigin = 'anonymous';
      document.head.appendChild(preconnect);
    }

    images.forEach((url, index) => {
      addResourceHint(url, index === 0 ? 'preload' : 'prefetch', index === 0 ? 'high' : null);
    });
  }

  function preloadImage(url) {
    if (!url) return Promise.resolve(null);
    if (imageCache.has(url)) return Promise.resolve(imageCache.get(url));
    if (imagePromises.has(url)) return imagePromises.get(url);

    const img = new Image();
    img.decoding = 'async';
    img.loading = 'eager';

    if ('fetchPriority' in img) {
      img.fetchPriority = 'high';
    }

    const promise = new Promise((resolve) => {
      img.onload = () => {
        const finish = () => {
          imageCache.set(url, img);
          resolve(img);
        };

        if (typeof img.decode === 'function') {
          img.decode().then(finish).catch(finish);
        } else {
          finish();
        }
      };

      img.onerror = () => {
        resolve(null);
      };
    });

    img.src = url;
    imagePromises.set(url, promise);
    return promise;
  }

  function preloadGalleryImages() {
    setupImageResourceHints();
    images.forEach((url) => preloadImage(url));
  }

  function preloadNearbyImages() {
    preloadImage(images[(currentIndex + 1) % images.length]);
    preloadImage(images[(currentIndex - 1 + images.length) % images.length]);
  }

  function renderDots() {
    if (!dotsContainer) return;

    dotsContainer.innerHTML = '';

    images.forEach((_, idx) => {
      const dot = document.createElement('button');
      dot.className = 'roux-dot';
      dot.type = 'button';
      dot.setAttribute('aria-label', 'Show image ' + (idx + 1));
      dot.setAttribute('aria-pressed', idx === currentIndex ? 'true' : 'false');

      if (idx === currentIndex) {
        dot.classList.add('active');
      }

      dot.addEventListener('click', () => showImage(idx));
      dotsContainer.appendChild(dot);
    });
  }

  function updateActiveDots() {
    const dots = document.querySelectorAll('.roux-dot');

    dots.forEach((dot, i) => {
      const active = i === currentIndex;
      dot.classList.toggle('active', active);
      dot.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function showImage(idx) {
    if (!images.length) return;

    currentIndex = (idx + images.length) % images.length;
    const url = images[currentIndex];

    if (mainImg) {
      mainImg.removeAttribute('srcset');
      mainImg.removeAttribute('sizes');
      mainImg.setAttribute('data-current-index', String(currentIndex));

      if (mainImg.getAttribute('src') !== url) {
        mainImg.src = url;
      }
    }

    updateActiveDots();
    preloadNearbyImages();
  }

  function setMainImageAttributes() {
    if (!mainImg) return;

    mainImg.loading = 'eager';
    mainImg.decoding = 'async';

    if ('fetchPriority' in mainImg) {
      mainImg.fetchPriority = 'high';
    }
  }

  function updateWhatsAppLink() {
    const item = bundleData[selectedPlan];
    const msg = encodeURIComponent("Hello, I'm interested in the ROUX Hair Texturizer - " + item.title + " (" + item.subtitle + ") - " + item.whatsappSubtitle + " for " + money(item.price));
    const href = 'https://wa.me/96181629644?text=' + msg;

    const whatsappBtn = document.getElementById('roux-whatsapp-btn');

    if (whatsappBtn) {
      whatsappBtn.href = href;
    }
  }

  function updateHeroPricing() {
    const item = bundleData[selectedPlan];
    const heroPrice = document.getElementById('roux-hero-price');
    const heroCompare = document.getElementById('roux-hero-compare');
    const heroBadge = document.getElementById('roux-hero-badge');
    const stickyPlan = document.getElementById('roux-sticky-plan');
    const stickyPrice = document.getElementById('roux-sticky-price');

    if (heroPrice) heroPrice.textContent = money(item.price);
    if (heroCompare) heroCompare.textContent = money(item.compareAt);
    if (heroBadge) heroBadge.textContent = item.badge;
    if (stickyPlan) stickyPlan.textContent = item.stickyLabel;
    if (stickyPrice) stickyPrice.textContent = money(item.price);
  }

  function selectPlan(plan) {
    const normalizedPlan = Number(plan);
    if (!bundleData[normalizedPlan]) return;

    selectedPlan = normalizedPlan;

    document.querySelectorAll('.roux-bundle-card').forEach((card) => {
      const isSelected = Number(card.getAttribute('data-plan')) === selectedPlan;
      card.classList.toggle('is-selected', isSelected);
      card.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
    });

    updateHeroPricing();
    updateWhatsAppLink();
  }

  function setButtonLoading(btn, isLoading, loadingText) {
    if (!btn) return '';

    const originalText = btn.textContent;
    btn.disabled = isLoading;

    if (isLoading && loadingText) {
      btn.textContent = loadingText;
    }

    return originalText;
  }

  function showCartMessage(message, isError) {
    const successDiv = document.getElementById('roux-cart-success');
    if (!successDiv) return;

    successDiv.textContent = message;
    successDiv.style.color = isError ? '#d60017' : '#38B6CC';
    successDiv.classList.add('show');

    setTimeout(() => {
      successDiv.classList.remove('show');
      successDiv.style.color = '#38B6CC';
    }, 2200);
  }

  async function addToShopifyCart(item) {
    if (typeof window.addProductToCart === 'function') {
      window.addProductToCart({
        title: 'ROUX Hair Texturizer',
        variant: item.title,
        price: item.price,
        variantId: item.variantId,
        quantity: 1,
        image: images[currentIndex],
        handle: 'roux-hair-texturizer'
      });

      return true;
    }

    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: Number(item.variantId),
        quantity: 1
      })
    });

    if (!res.ok) {
      throw new Error('Unable to add item to cart');
    }

    try {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('cart:updated'));
    } catch (e) {}

    return true;
  }

  function tryOpenCartDrawer() {
    const cartButton = document.getElementById('cartButton') || document.querySelector('.cart-icon');

    if (cartButton && typeof cartButton.click === 'function') {
      setTimeout(() => cartButton.click(), 250);
    }
  }

  async function addSelectedPlanToCart(sourceButton) {
    const item = bundleData[selectedPlan];
    const btn = sourceButton || document.getElementById('roux-add-to-cart');

    if (!btn || !item) return;

    const originalText = setButtonLoading(btn, true, 'Adding...');

    try {
      await addToShopifyCart(item);
      showCartMessage(item.title + ' added to cart successfully!', false);
      tryOpenCartDrawer();
    } catch(e) {
      showCartMessage('Error adding to cart. Please try again.', true);
    }

    setTimeout(() => {
      btn.disabled = false;
      btn.textContent = originalText;
    }, 1200);
  }

  async function handleBuyNow() {
    const item = bundleData[selectedPlan];
    const buyNowBtn = document.getElementById('roux-buy-now');

    if (!buyNowBtn || !item) return;

    const originalText = setButtonLoading(buyNowBtn, true, 'Processing...');

    try {
      await addToShopifyCart(item);
      window.location.href = '/checkout';
    } catch(e) {
      alert('Unable to process. Please try again.');
      buyNowBtn.disabled = false;
      buyNowBtn.textContent = originalText;
    }
  }

  function handleStickyBuyNow() {
    const item = bundleData[selectedPlan];
    const stickyBuyNowBtn = document.getElementById('roux-sticky-buy-now');

    if (!item) return;

    if (stickyBuyNowBtn) {
      stickyBuyNowBtn.disabled = true;
      stickyBuyNowBtn.textContent = 'Processing...';
    }

    window.location.href = '/cart/' + Number(item.variantId) + ':1?checkout';
  }

  function initBundleCards() {
    document.querySelectorAll('.roux-bundle-card').forEach((card) => {
      card.addEventListener('click', () => selectPlan(card.getAttribute('data-plan')));

      card.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          selectPlan(card.getAttribute('data-plan'));
        }
      });
    });
  }

  function initCartButtons() {
    const addToCartBtn = document.getElementById('roux-add-to-cart');
    const stickyAddBtn = document.getElementById('roux-sticky-add');
    const stickyBuyNowBtn = document.getElementById('roux-sticky-buy-now');
    const buyNowBtn = document.getElementById('roux-buy-now');

    if (addToCartBtn) {
      addToCartBtn.addEventListener('click', () => addSelectedPlanToCart(addToCartBtn));
    }

    if (stickyAddBtn) {
      stickyAddBtn.addEventListener('click', () => addSelectedPlanToCart(stickyAddBtn));
    }

    if (stickyBuyNowBtn) {
      stickyBuyNowBtn.addEventListener('click', handleStickyBuyNow);
    }

    if (buyNowBtn) {
      buyNowBtn.addEventListener('click', handleBuyNow);
    }
  }

  function initGallery() {
    if (prevBtn) {
      prevBtn.addEventListener('click', () => showImage(currentIndex - 1));
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', () => showImage(currentIndex + 1));
    }

    let startX = 0;

    if (mainImg) {
      mainImg.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
      }, { passive: true });

      mainImg.addEventListener('touchend', (e) => {
        const diff = e.changedTouches[0].clientX - startX;

        if (Math.abs(diff) > 40) {
          showImage(currentIndex + (diff > 0 ? -1 : 1));
        }
      }, { passive: true });
    }
  }

  function initReviewsLink() {
    const reviewsLink = document.getElementById('roux-reviews-link');
    if (!reviewsLink) return;

    reviewsLink.addEventListener('click', () => {
      const target = document.getElementById('shopify-product-reviews') || document.querySelector('[data-reviews]') || document.querySelector('.jdgm-widget') || document.querySelector('.loox-reviews-default');

      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }

  function initCollapsibles() {
    const collapsibles = document.querySelectorAll('.roux-collapsible');

    collapsibles.forEach((coll) => {
      const header = coll.querySelector('.roux-collapsible-header');
      const content = coll.querySelector('.roux-collapsible-content');
      const iconSpan = header ? header.querySelector('.roux-collapsible-icon') : null;

      if (!header || !content || !iconSpan) return;

      function toggle() {
        const isOpen = content.classList.contains('open');
        content.classList.toggle('open', !isOpen);
        iconSpan.textContent = isOpen ? '+' : '−';
        header.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      }

      header.addEventListener('click', toggle);
      header.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          toggle();
        }
      });

      content.classList.remove('open');
      iconSpan.textContent = '+';
      header.setAttribute('aria-expanded', 'false');
    });
  }

  function initVideoAutoplay() {
    const videos = document.querySelectorAll('.roux-proof-video');

    videos.forEach((video) => {
      video.muted = true;
      video.loop = true;
      video.playsInline = true;
      video.controls = false;

      const playPromise = video.play();

      if (playPromise !== undefined) {
        playPromise.catch(() => {
          const playOnInteraction = () => {
            video.play().catch(() => {});
            document.removeEventListener('click', playOnInteraction);
            document.removeEventListener('touchstart', playOnInteraction);
          };

          document.addEventListener('click', playOnInteraction);
          document.addEventListener('touchstart', playOnInteraction);
        });
      }
    });
  }

  function initStickyBarVisibility() {
    const bar = document.getElementById('roux-sticky-buy-bar');
    const mainBuyActions = document.getElementById('roux-main-buy-actions');

    if (!bar || !mainBuyActions) return;

    function shouldHideForDrawerOrMenu() {
      return document.body.classList.contains('roux-cart-open') ||
        document.body.classList.contains('menu-open') ||
        document.body.classList.contains('overflow-hidden');
    }

    function updateStickyState() {
      const isMobile = window.matchMedia('(max-width: 768px)').matches;
      const actionsRect = mainBuyActions.getBoundingClientRect();
      const passedMainButtons = actionsRect.bottom <= 0;
      const shouldShow = isMobile && passedMainButtons && !shouldHideForDrawerOrMenu();

      bar.classList.toggle('is-visible', shouldShow);
    }

    let ticking = false;

    function requestStickyUpdate() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(() => {
        updateStickyState();
        ticking = false;
      });
    }

    window.addEventListener('scroll', requestStickyUpdate, { passive: true });
    window.addEventListener('resize', requestStickyUpdate);
    document.addEventListener('cart:updated', requestStickyUpdate);
    document.addEventListener('cart:refresh', requestStickyUpdate);

    const observer = new MutationObserver(requestStickyUpdate);
    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });

    updateStickyState();
  }

  setMainImageAttributes();
  preloadGalleryImages();
  renderDots();
  initGallery();
  showImage(0);
  initBundleCards();
  selectPlan(1);
  initCartButtons();
  initReviewsLink();
  initCollapsibles();
  initVideoAutoplay();
  initStickyBarVisibility();
})();
